import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';

import { styles, TagStyles } from './Tag.styles';

const Tag = ({ data, type }: { data: any; type?: 'pedido' | 'pagamento' }) => {
  return (
    <TagStyles
      css={styles.tag}
      variant={data.tagVariant}
      data-variant-orders={data.tagVariant}
      shape='solid'
      aria-label={type ? `Status do ${type}: ${data.tagText}` : `Status: ${data.tagText}`}
    >
      <ResponsiveFloraTypography aria-hidden fontSize='exceptionsAuxiliar' fontWeight='medium'>
        {data.tagText}
      </ResponsiveFloraTypography>
    </TagStyles>
  );
};

export default Tag;
